export const ClaimDocumentsTypes = {
  ENDING_VALUE_FORM: 'ENDING_VALUE_FORM',
  SALES_RECEIPT: 'SALES_RECEIPT',
  RETAINED_OWNERSHIP_FORM: 'RETAINED_OWNERSHIP_FORM',
  NOTICE_OF_PROBABLE_LOSS_FORM: 'NOTICE_OF_PROBABLE_LOSS_FORM',
  CLAIMS_PACKET: 'CLAIMS_PACKET',
} as const;

export type ClaimDocumentTypes =
  (typeof ClaimDocumentsTypes)[keyof typeof ClaimDocumentsTypes];
